<script>
    import {searchStore} from '@js/stores/searchStore';
    import {mapStore} from '@js/stores/mapStore';

    import {fetchSearch} from '@js/actions/searchActions';

    import {onPageReady, isPresent} from '@js/modules/utils';
    import I18n from '@js/modules/translations';
    import Notification from '@js/components/layouts/notification';

    import Autocompletion from '@js/components/search/Autocompletion.svelte';

    import UserFilters from '@js/components/user/filter/UserFilters.svelte';
    import ListMap from '@js/components/maps/ListMap.svelte';
    import RideList from '@js/components/ride/list/RideList.svelte';

    const {
        user,
        defaultRideType
    } = $props();

    let userRideFilters = $state();
    let initRidesLoaded = $state(false);
    let userRides = $state([]);

    const _performSearch = ({
                                query,
                                filters,
                                location
                            }) => {
        if (query) {
            searchStore.query = query;
        }
        if (filters) {
            searchStore.selectedFilters = filters || {};
        }

        const searchParams = {
            query: searchStore.query,
            location,
            userId: user.id,
            order: 'performed_desc',
            ...searchStore.selectedFilters
        };

        searchStore.isSearching = true;

        return fetchSearch(searchParams)
            .then((response) => {
                if (!response) {
                    return;
                }

                if (!initRidesLoaded) {
                    initRidesLoaded = true;
                }

                searchStore.isSearching = false;

                userRides = response?.rides || [];

                if (!userRideFilters) {
                    const userFilters = response.aggregations.rides;
                    if (!userFilters) {
                        return;
                    }

                    userRideFilters = {
                        distance: {
                            min: userFilters.min_distance,
                            max: userFilters.max_distance
                        },
                        duration: {
                            min: userFilters.min_duration,
                            max: userFilters.max_duration
                        },
                        levels: Object.keys(userFilters.level),
                        rideTypes: Object.keys(userFilters.ride_type)
                    };
                }

                if (userRides.length === 0 && isPresent(searchStore.selectedFilters)) {
                    Notification.info(I18n.t('js.user.common.no_results'));
                } else {
                    Notification.hide();
                }

                return userRides;
            });
    };

    const onSearchSubmit = (selectedLocation) => {
        const searchParams = {};

        if (selectedLocation.type === 'ride') {
            searchParams.query = selectedLocation.value;
        } else if (selectedLocation.type === 'location' && (selectedLocation.bbox || selectedLocation.center)) {
            searchParams.location = {
                placeType: selectedLocation.placeType,
                bbox: !!selectedLocation.bbox ? [...selectedLocation.bbox] : null,
                center: !!selectedLocation.center ? [...selectedLocation.center] : null
            };
        }

        _performSearch(searchParams)
            .then((rides) => {
                mapStore.map.displayRideMarkers({
                    strict: true,
                    ridesData: $state.snapshot(rides),
                    clear: true,
                    fitBounds: true
                });
            });
    };

    const onFilterChange = (selectedFilters) => {
        _performSearch({filters: selectedFilters})
            .then((rides) => {
                mapStore.map.displayRideMarkers({
                    strict: true,
                    ridesData: $state.snapshot(rides),
                    clear: true,
                    fitBounds: true
                });
            });
    };

    onPageReady(() => {
        _performSearch({
            query: '*'
        });
    }, 100);
</script>

<div class="ride-show">
    <h1 class="h1-title mt-6">
        {I18n.t(`js.user.show.title.${window.currentUserId === user.id ? 'connected' : 'default'}`, {pseudo: user.pseudo})}
    </h1>

    <Autocompletion id="user-show-search"
                    class="my-8"
                    placeholder={I18n.t('js.user.show.search.placeholder')}
                    searchFeatures={['location', 'ride']}
                    searchFilters={{userId: user.id}}
                    rideResultsFirst={true}
                    useFirstQueryOnEnter={false}
                    onSubmit={onSearchSubmit}/>

    {#if userRideFilters && initRidesLoaded}
        <UserFilters allFilters={userRideFilters}
                     onFilterChange={onFilterChange}/>
    {/if}

    {#if initRidesLoaded}
        <ListMap mapId="user-rides"
                 rides={userRides}/>

        <RideList defaultRideType={defaultRideType}
                  rides={userRides}/>
    {/if}
</div>
